import "./Services.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";
const Services = () => {

  return (
    <div id="service-product" className="productmainclass">
       <div className="Container-main">
        <div className="serviceContent">
          
           <h2>Design, Build, and Scale—All With One Expert Team</h2>
          <p>
        Partner with a product development company delivering product development services and MVP consulting to design, develop, and launch products that delight users while supporting your business growth goals.
</p>
          <div><Link to='/contact_us' className="link"><Button  arrowColor="purple" text="Get a Free Consultation Today"/></Link></div>
        </div>
     </div>
    </div>
  );
};

export default Services;
